import React, { useState } from 'react';
import { Grid } from '@mui/material';

import { useAppSelector } from 'store/hooks';
import { appliedFiltersSelector } from 'store/filter/filterSelector';
import AuthContainer from 'components/AuthContainer';
import TopSection from 'components/TopSection/TopSection';
import type { IUser } from 'api/services/dataEndpoints';
import StyledActivities from './ConversationExplorer.styles';
import MessagesList from './components/MessagesList';
import UsersList from '../../components/UsersList/UsersList';

const ConversationExplorer: React.FC = () => {
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [selectedUser, setSelectedUser] = useState<IUser | null>();

  const filters = useAppSelector(appliedFiltersSelector);

  const handleUserSelect = (user: IUser | null) => {
    setSelectedUser(user);
  };

  return (
    <AuthContainer>
      <TopSection title="Conversations" />
      <StyledActivities>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <UsersList
              selectedUserId={selectedUserId}
              onUserSelect={handleUserSelect}
              userStatus={filters.userStatus}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <MessagesList
              selectedUser={selectedUser}
            />
          </Grid>
        </Grid>
      </StyledActivities>
    </AuthContainer>
  );
};

export default ConversationExplorer;
